export default {
    home: {
        coreCapabilities: {
            name: 'コア能力',
            title0: '研究開発イノベーション',
            description0: '継続的な研究開発投資、医薬技術革新の推進',
            title1: '品質保証',
            description1: '厳格な品質管理システム、製品の安全性と信頼性の確保',
            title2: 'グローバル展開',
            description2: '国際戦略、グローバル市場の拡大',
        },
        profile: {
            title: '会社概要',
            subtitle: 'ヨンタオについて',
        },
        companyProfile: {
            name: '会社概要',
            specialtyName: '当社の専門性',
            teamName: '当社のチーム',
            missionName: '当社のミッション',
            layoutName: '全国展開',
            expertise: '成熟した医薬品を中国に導入し、競争力のある高品質原薬を世界に展開',
            team: '医学・薬学博士、弁護士、医師、企業幹部で構成',
            mission: '影響力のあるヘルスケアソリューションの推進',
            offices: {
                city0: '南通', type0: '本社（中国）',
                city1: '香港', type1: '本社（グローバル）',
                city2: '杭州', type2: '事務所',
                city3: '重慶', type3: '事務所',
                city4: '上海', type4: '事務所',
                city5: '合肥', type5: '事務所'
            }
        },
        companyStats: {
            name: '会社概況',
            title0: '年間収益',
            value0: '26億元',
            description0: '2023年に達成した強力な収益',
            title1: '利益率',
            value1: '8%',
            description1: '安定した財務パフォーマンス',
            title2: 'プロフェッショナルチーム',
            value2: '485+',
            description2: '献身的な医薬専門家'
        },
        strategicGoals: {
            name: '戦略目標',
            year0: '2027年',
            target0: '年間3つの新製品',
            description0: '最も効率的な新製品発売企業になる',
            year1: '2028年',
            target1: '1億ドル',
            description1: '専門製薬会社としての価値目標を達成',
            year2: '2030年',
            target2: '5億ドル',
            description2: '業界のリーダーになる'
        },
        regions: {
            title: 'ヨンタオ製薬オフィスシステム(OA)',
            formLabel0: "地域を選択してください",
            placeholder0: "ログイン地域を選択してください",
            formLabel1: "従業員番号",
            placeholder1: "従業員番号を入力してください",
            formLabel2: "ログインパスワード",
            placeholder2: "ログインパスワードを入力してください",
            buttonName: 'ログイン',
            errorMsg: '完全なログイン情報を入力してください',
            errorNames: ['アカウントが存在しません', 'パスワードがアカウントと一致しません'],
            label0: '中国本土', value0: 'mainland',
            label1: '香港・マカオ・台湾', value1: 'gat',
            label2: 'ヨーロッパ', value2: 'europe',
            label3: '北米', value3: 'north_america',
            label4: '南米', value4: 'south_america',
            label5: 'アフリカ', value5: 'africa',
            label6: '東アジア', value6: 'east_asia',
            label7: '南アジア', value7: 'south_asia',
            label8: '中央アジア', value8: 'central_asia',
            label9: '西アジア', value9: 'west_asia'
        },
        productCategories: {
            name: '製品カテゴリー',
            name0: '処方薬',
            products0: ['心臓血管薬', '抗生物質', '消化器系薬'],
            name1: '一般用医薬品',
            products1: ['風邪薬', '鎮痛剤', 'ビタミン剤'],
            name2: '健康食品',
            products2: ['栄養補助食品', '健康食品', '機能性飲料'],
            name3: '医療機器',
            products3: ['医療設備', '医療消耗品', '検査機器'],
        },
        researchAreas: {
            title: '研究開発分野',
            name0: '神経学と心臓血管',
            description0: '神経系疾患と心臓血管の健康に関する革新的な治療法に焦点',
            projects0: ['メトプロロール', '脳血管疾患研究'],
            name1: '腫瘍学',
            description1: '革新的な抗がん剤と治療法の開発',
            projects1: ['エンザルタミド', '標的治療'],
            name2: '消化器系と呼吸器系',
            description2: '消化器系と呼吸器系疾患の治療薬の研究開発',
            projects2: ['消化酵素研究', '呼吸器治療'],
        },
        complianceTraining: {
            title: 'コンプライアンス研修',
            categories: {
                title: '研修カテゴリー',
                list: [
                    '新入社員研修（四半期ごと）',
                    '年次総会（年単位）',
                    '事業部門会議（不定期）- サプライチェーン研修（不定期）',
                    'オンライン研修（不定期）'
                ]
            },
            content: {
                title: '研修内容',
                list: [
                    'コンプライアンス基準とシステム',
                    'コンプライアンス行動と文化規範 - 経費精算ポリシー',
                    '有害事象モニタリングと報告',
                    '腐敗防止と商業贈収賄'
                ]
            },
            vision: {
                title: '研修のビジョン',
                list: [
                    '研修に基づく試験',
                    '結果のマーキング'
                ]
            },
            update: {
                title: 'コンテンツ更新',
                list: [
                    '年1回の更新',
                    '最新のRDPAC要件に基づく - パートナーのコンプライアンスシステム要件に基づく',
                    '内部および外部監査結果に基づく'
                ]
            }
        },
    },
    menu: {
        home: 'ホーム',
        resources: '医薬品リソース',
        about: '会社概要',
        contact: 'お問い合わせ'
    },
    hero: {
        title: '永涛製薬',
        subtitle: '中国の専門医薬品業界の新時代を創造',
        description: '永涛は、中国市場への革新的な製品の提供において卓越した効率性を持つ一流の製薬会社です',
        learnMore: '詳細を見る',
        oaSystem: '社員ポータル(OA)'
    },
    sections: {
        capabilities: '中核能力',
        research: '研究分野',
        profile: '会社概要',
        products: '製品カテゴリー',
        goals: '戦略目標',
        overview: '会社概要',
        compliance: 'コンプライアンス研修'
    },
    oa: {
        title: '永涛製薬OAシステム',
        region: '地域を選択',
        employeeId: '社員番号',
        password: 'パスワード',
        login: 'ログイン',
        errors: {
            incomplete: 'すべての項目を入力してください',
            noAccount: 'アカウントが見つかりません',
            wrongPassword: 'パスワードが正しくありません'
        }
    },
    about: {
        title: '永涛について',
        subtitle: '製薬・化学産業の新興リーダー',
        company: {
            title: '会社概要',
            description: '永涛は、中国南通に戦略的本社を置く製薬・化学産業の新興リーダーです。杭州、重慶、香港、上海、合肥など、全国に事務所を展開しています。2022年に経験豊富な製薬業界の幹部と財務力のある投資家によって設立され、機動性と専門性を組み合わせて、ダイナミックで信頼できるパートナーシップを形成しています。'
        },
        mission: {
            title: '私たちの使命',
            description: '実績のある医薬品を中国市場に育成・統合し、中国固有のニーズと基準に適合させながら、強力なパートナーシップネットワークを育成すること。'
        },
        strategicGoals: {
            title: '戦略目標',
            goals: {
                goal2028: {
                    title: '2028年目標',
                    description: 'R&Dへの投資によるイノベーションの促進、医療機関とのパートナーシップ強化、市場浸透戦略の強化により、1億ドルの専門製薬会社となる。'
                },
                goal2030: {
                    title: '2030年ビジョン',
                    description: '事業規模と効率性の拡大、製造プロセスの合理化、新興技術の優位性を活かしたコスト効率の高い生産に焦点を当て、5億ドルの企業へと変革する。'
                },
                innovation: {
                    title: '製品イノベーション',
                    description: '2027年から、最先端の研究への継続的な投資と部門横断的な協力を通じて、毎年3つの専門的な新製品を導入する、最も効果的な新製品発売企業となる。'
                }
            }
        },
        capabilities: {
            title: '中核能力',
            items: {
                innovation: {
                    title: '研究開発イノベーション',
                    description: '国内の研究開発に積極的に取り組み、革新的で地域に合わせた医薬品の創造に専念し、主要な研究機関との戦略的パートナーシップを通じて、中国での影響力のあるヘルスケアソリューションの開発の最前線に立ち続けています。'
                },
                collaboration: {
                    title: 'グローバル協力',
                    description: '外国企業の中国市場参入における優先パートナーとして、効率的な製品登録と収益性の高い市場戦略を提供します。専門家チームが、すべての製品がシームレスかつ合法的に市場に参入することを保証します。'
                },
                network: {
                    title: '戦略的ネットワーク',
                    description: '南通、杭州、重慶、香港、上海、合肥など、全国の戦略的オフィスネットワークを通じて、卓越性と機動性を持って多様なプロジェクトのニーズに対応できます。'
                }
            }
        }
    },
    contact: {
        companyName: '香港永濤製薬有限会社',
        address: '香港旺角花園街2-16號好景商業中心16階4室',
        phone: '+86 18651110588',
        email: 'hao.xiaofeng@yongtao-hk.com',
        logoAlt: '永濤製薬',
        mapTitle: '香港永濤製薬有限会社'
    },
    products: {
        title: '製品センター',
        subtitle: '永濤製薬は患者様に高品質で信頼性の高い医薬品を提供することに努めています',
        categories: {
            neurological: {
                name: '神経系',
                products: {
                    flunarizine: {
                        name: 'フルナリジン塩酸塩カプセル',
                        description: '片頭痛および血管性頭痛の予防と治療'
                    },
                    levodopa: {
                        name: 'レボドパ・ベンセラジド配合錠',
                        description: 'パーキンソン病の治療'
                    }
                }
            },
            cardiovascular: {
                name: '循環器系',
                products: {
                    metoprolol: {
                        name: 'メトプロロール酒石酸塩錠',
                        description: '高血圧、狭心症などの循環器疾患の治療'
                    },
                    sacubitril: {
                        name: 'サクビトリル・バルサルタンナトリウム錠',
                        description: '慢性心不全の治療'
                    }
                }
            },
            antiviral: {
                name: '抗ウイルス・腫瘍',
                products: {
                    peramivir: {
                        name: 'ペラミビル注射液',
                        description: 'インフルエンザウイルス感染症の治療'
                    },
                    enzalutamide: {
                        name: 'エンザルタミドソフトカプセル',
                        description: '前立腺がんの治療'
                    }
                }
            }
        }
    },
    resources: {
        title: '医薬品リソースセンター',
        subtitle: '革新的な医薬品ソリューション',
        categories: {
            neurological: {
                name: '神経系用薬',
                products: {
                    flunarizine: {
                        name: 'フルナリジン塩酸塩カプセル',
                        description: '片頭痛および眩暈の予防性治療、脳血液循環の改善'
                    },
                    levodopa: {
                        name: 'レボドパ・ベンセラジド配合錠',
                        description: 'パーキンソン病の治療薬、運動機能の改善'
                    }
                }
            },
            cardiovascular: {
                name: '循環器系用薬',
                products: {
                    metoprolol: {
                        name: 'メトプロロール酒石酸塩錠',
                        description: '高血圧、狭心症、不整脈の治療'
                    },
                    sacubitril: {
                        name: 'サクビトリル・バルサルタンナトリウム錠',
                        description: '慢性心不全の革新的な治療薬'
                    }
                }
            },
            antitumor: {
                name: '抗腫瘍薬',
                products: {
                    enzalutamide: {
                        name: 'エンザルタミドソフトカプセル',
                        description: '去勢抵抗性前立腺がんの治療'
                    }
                }
            }
        },
        tags: {
            migraine: '片頭痛',
            dizziness: '眩暈',
            prescription: '処方薬',
            parkinsons: 'パーキンソン病',
            movement_disorder: '運動障害',
            hypertension: '高血圧',
            angina: '狭心症',
            heart_failure: '心不全',
            innovative: '革新薬',
            tumor: '腫瘍'
        }
    },
    footer: {
        contact: {
            title: 'お問い合わせ',
            phone: '+86 18651110588',
            email: 'hao.xiaofeng@yongtao-hk.com',
            address: '香港旺角花園街2-16號好景商業中心16階4室'
        },
        quickLinks: {
            title: 'クイックリンク',
            resources: '医薬品リソース',
            about: '会社概要',
            contact: 'お問い合わせ'
        },
        social: {
            title: 'フォローする'
        },
        copyright: '香港永濤製薬有限会社 全著作権所有'
    }
}